import React from 'react';
import {  exclametry_bg_gray, CorrectTick, exclametry_bg_gray_up, exclametry_red_dark, exclametaryYellowInfoIcon, } from '../../../../assets/images';

const bgColor = {'red':'#FEEEEE', 'green':'#DBFBE9', 'blue': '#BAD0FC', 'yellow' : '#FEFBED'}
const bannerIcons = {'red':exclametry_red_dark, 'green':CorrectTick, 'blue': exclametry_bg_gray_up, 'yellow': exclametaryYellowInfoIcon}

const UserAlert = ({ icon='default', para, btntext, btnHandler, paraClasses='', imgClasses='', classes = '', bodyClasses = 'items-center' }) => {
  return (
    <div className={`rounded-lg ${classes}`} style={{ background: bgColor[icon] || '#F5F8FF' }}>
      <div className={`flex ${bodyClasses}`}>
        <img
          src={bannerIcons[icon] || exclametry_bg_gray}
          alt='bannere-icon'
          className={imgClasses}
        />
        <div className='ml-3 flex-1 flex justify-between items-center'>
          <p className={'text-base mb-0 ' + paraClasses}>{para}</p>
          {btntext && (
            <button className='text-white font-semibold text-base px-4 py-2 bg-blue-600 rounded-md focus:outline-none hover:bg-blue-600' onClick={btnHandler}>
              {btntext}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserAlert;
